import React from 'react';
import LazyLoad from 'react-lazyload';

const BoughtTogether = ({ boughtTogether }) => {
	return (
		<li>
			<a
				href={ boughtTogether.accessoryUrl }
			>
				<div className="product-img">
					<LazyLoad once={ true } offset={ 200 }>
						<img src={ boughtTogether.imageUrl } alt="" />
					</LazyLoad>
				</div>
				<h3 className="product-title">
					{ boughtTogether.title }
				</h3>
			</a>
		</li>
	);
};

export default BoughtTogether;


// WEBPACK FOOTER //
// ./src/pages/product/boughttogether/BoughtTogether.js